<template>
  <panel
    :icon="'notes'"
    :heading="label"
  >
    <div class="highlight-title">
      Cardiovascular System 1 of 11
    </div>
    <div class="highlight">
      <a href="#">40-pack-year history of smoking</a>
    </div>
  </panel>
</template>

<script>
import Panel from '@components/singletons/panel';

export default {
  components: { Panel },
  props: {
    label: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang='scss' scoped>
  .highlight-title {
    font-size: rem-calc(12);
    font-weight: $bold;
    margin-bottom: rem-calc(12);
  }

  .highlight {
    background-color: #FDF799;
    font-size: rem-calc(12);
    display: inline-block;
    padding: rem-calc(4);
  }
</style>
